<template>
  <div :class="cn(variants({ outline, size, variant }), props.class)">
    <svg class="h-full w-full" viewBox="0 0 6 6">
      <circle cx="3" cy="3" r="3" fill="currentColor" />
    </svg>
  </div>
</template>

<script setup>
import { cn } from "@/Utils/cn";
import { variants } from ".";

const props = defineProps({
  variant: {
    type: String,
    default: "low",
  },
  size: {
    type: String,
    default: "sm",
  },
  outline: { type: Boolean, default: false },
});
</script>
